import { propertyGroupQueryKeys as e } from "./propertyGroupQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyGroupsApi as n } from "@maat/api-main";
//#region src/propertyGroups/usePropertyGroupsQuery.ts
var r = (r) => t({
	queryKey: e.list(r || void 0),
	queryFn: () => n.getGroups(r ? { search: r } : void 0)
});
//#endregion
export { r as usePropertyGroupsQuery };
